import React, { PureComponent, PropTypes } from 'react'
import styles from './styles'

export default class Content extends PureComponent {
  static propTypes = {
    children: PropTypes.array,
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.content}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Content/Content.js
 **/